// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__1Pspz","header":"Layout_header__rn4Wl","sidebar":"Layout_sidebar__IeXdb","main":"Layout_main__0b20O","footer":"Layout_footer__2L9iz"};